var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/text-character-counter.tsx";
import classNames from 'clsx';
import React from 'react';
import { length } from 'stringz';

const TextCharacterCounter = _ref => {
  let {
    text,
    max
  } = _ref;

  const checkRemainingText = diff => {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('text-sm font-medium', {
        'text-gray-700': diff >= 0,
        'text-secondary-600': diff < 0
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 7
      }
    }, diff);
  };

  const diff = max - length(text);
  return checkRemainingText(diff);
};

export default TextCharacterCounter;